import { render, staticRenderFns } from "./BiddingTab.vue?vue&type=template&id=19e4ae2e&scoped=true&"
import script from "./BiddingTab.vue?vue&type=script&lang=js&"
export * from "./BiddingTab.vue?vue&type=script&lang=js&"
import style0 from "./BiddingTab.vue?vue&type=style&index=0&id=19e4ae2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e4ae2e",
  null
  
)

export default component.exports